import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { PaginationRequest } from '@shared/services';
import { RequestHelper } from '@shared/helpers/request.helper';

@Injectable({ providedIn: 'root' })
export class LearnerStudyPlanApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) { }

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/learner-study-plans`;
    }

    getStudyPlans(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.get<any>(this.url, { params: options });
    }
    
    getOptions(req: PaginationRequest, body?: any): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.post<any>(`${this.url}/options`, body || {}, { params: options });
    }

    createStudyPlan(studyPlan: any): Observable<any> {
        return this.httpClient.post<any>(this.url, studyPlan);
    }

    updateStudyPlan(studyPlan: any): Observable<any> {
        return this.httpClient.put<any>(this.url, studyPlan);
    }

    updateOwnStudyPlan(studyPlan: any): Observable<any> {
        return this.httpClient.put<any>(`${this.url}/self`, studyPlan);
    }

    deleteStudyPlan(id: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/${id}`);
    }

    deleteOwnStudyPlan(id: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/self/${id}`);
    }
}

